module.exports = __webpack_public_path__ + "img/OurEvaluationQuotes-02.4e6df264.svg";